import EventHubMixin from '@/mixins/EventHub.js'

export default
{
    name: 'app-page-404',

    mixins:
    [
        EventHubMixin
    ],

    created()
    {
        // Title
        document.title = this.$root.config.title
    },

    mounted()
    {
        this.$eventHub.$emit('headerLogo.setState', { state: 'logo' })
    }
}



// WEBPACK FOOTER //
// ./src/components/app-page-404/script.js